import { render, staticRenderFns } from "./cardView.vue?vue&type=template&id=bd3957a8"
import script from "./cardView.vue?vue&type=script&lang=js"
export * from "./cardView.vue?vue&type=script&lang=js"
import style0 from "./cardView.vue?vue&type=style&index=0&id=bd3957a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports